import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { EntitlementGate } from '@/components/gates';
import { QaSessionSummary } from '@/components/scout';

export const Route = createFileRoute('/scout/qa/$runId/summary')({
  component: QaSummaryPage,
});

function QaSummaryPage() {
  const { runId } = Route.useParams();
  return (
    <EntitlementGate module="scout">
      <div className="space-y-6">
        <PageHeader title="QA Session Summary" backTo={`/scout/qa/${runId}`} />
        <QaSessionSummary runId={runId} />
      </div>
    </EntitlementGate>
  );
}